import React from "react";
import classes from "./ActiveQuiz.module.css";

import AnswersList from '../AnswersList/AnswersList'


const ActiveQuize = props => (
  <div className={classes.ActiveQuiz}>
    <p className={classes.Question}>
      <span>
        <strong>{`${props.answerNumber}. `}</strong>&nbsp;
        {props.question}
      </span>
      <small>{props.answerNumber} из {props.quizLength}</small>
    </p>
    <AnswersList {...props}/>
  </div>
);

export default ActiveQuize;
